import Vue from "vue";
import App from "./App";
import VueRouter from "vue-router";
import routes from "./router";
import { sync } from "vuex-router-sync";
import VeeValidate from "vee-validate";
import store from "./store";
import DataTable from "vue-good-table";

import 'vue-good-table/dist/vue-good-table.css';

Vue.use(VueRouter);
Vue.use(VeeValidate);
Vue.use(DataTable);

// Routing logic
let router = new VueRouter({
  routes: routes,
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: function(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

// Some middleware to check for authentication
router.beforeEach((to, from, next) => {
  if (to.meta.auth && window.localStorage.getItem("token") === null) {
    return next("/");
  }
  if (to.meta.guest && window.localStorage.getItem("token")) {
    return next("/dashboard");
  }
  return next();
});

sync(store, router);

Vue.config.productionTip = false;

/* eslint-disable */


// Check local storage to handle refreshes
if (window.localStorage) {
  if (window.localStorage.getItem("user")) {
    store.commit("SET_USER", JSON.parse(window.localStorage.getItem("user")));
    store.commit("SET_TOKEN", window.localStorage.getItem("token"));
  }
  if (window.localStorage.getItem("services")) {
    store.commit("SET_SERVICES", JSON.parse(window.localStorage.getItem("services")));
  } else {
    store.commit("SET_SERVICES", null);
  }
}

new Vue({
  store,
  el: "#app",
  router,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js